//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
// import wxPay from '@/js/mixins/wxPay.js'
import couponLine from '@/components/coupon/index.vue'
import calendarpage from '@/components/calendarPage/calendarpage.vue'
import uniIcons from "@/components/uni-icon/uni-icon.vue"
import uniNumberBox from "@/components/uni-number-box/uni-number-box.vue"
import showMask from '@/components/mask/mask.vue'
import paymentSelect from '@/components/paymentSelect/index.vue'
import uParse from '@/components/gaoyia-parse/parse.vue'
export default {
  // mixins: [wxPay],
  components: { paymentSelect, calendarpage, showMask, uniIcons, couponLine, uniNumberBox, uParse },
  data() {
    return {
      loading: false,
      submitLoading: false,
      calanderLoading: false,
      // heights: 0,
      id: '',
      // sProductId: '',
      // aProductId: '',
      // productTypeCode: '',
      range: [],
      info: {
        checkInDate: this.formatDate(new Date()),
        checkOutDate: ''
      },
      rangeObj: {
        start: '',
        end: ''
      },
      IsCalender: false,
      close: false,
      currentDate: this.formatDate(new Date()),
      minDate: '',
      maxDate: '',
      dataFromFather: '',
      forms: {
        price: 0,
        num: 1,
        maxNum: 1,
        minNum: 1,
        contactName: '',
        tel: '',
        IDNumber: ''
      },
      introduction: '',
      returnPrompt: '',
      cancelType: '',
      isNameError: false,
      isPhoneError: false,
      isIDError: false,
      modal: false,
      payLoading: false,
      isNeedID: false,
      orderId: '',
      weixinBridgeInfo: {},
      hasCode: 1,
      countPrice: 0,
      couponCode: '',
      orderType: 'ticket',
      memberId: '',
      coupons: [],
      showPaymentSelect: false,
      defaultTxt: '请选择'
    }
  },
  watch: {
    info: function (val) {
      if (val.checkInDate === '') {
        this.info.checkInDate = this.formatDate(new Date())
      }
    }
  },
  computed: {
    startDate() {
      return this.addZero(this.info.checkInDate)
    },
    originalPrice() {
      return parseFloat(this.forms.num * this.forms.price).toFixed(2)
    },
    price() {
      let price = parseFloat(this.forms.num * this.forms.price - this.countPrice).toFixed(2)
      return price <= 0 ? 0.01 : price
    }
  },
  onLoad(event) {
    this.id = event.id
    // this.sProductId = event.sProductId
    // this.aProductId = event.aProductId
    // this.productTypeCode = event.productTypeCode
    this.queryData()
    // this.heights = window.screen.height * 0.6
    // this.$nextTick(() => {
    //   let order = document.querySelector('.order-main')
    //   if (order.offsetHeight < document.documentElement.clientHeight) {
    //     order.style.minHeight = (document.documentElement.clientHeight - document.querySelector('.submit-bar').offsetHeight - 100) + 'px'
    //   }
    // })
  },
  onShow() {
    this.memberId = this.$store.state.userInfo.memberId
    if (this.memberId) {
      this.queryUserinfo()
      // this.getCoupon()
    }
  },
  methods: {
    huangxing() {
      // this.timeInitial()
      // if (this.range.length > 0) {
      if (!this.calanderLoading) {
        this.close = false
        this.IsCalender = true
      } else {
        // Notify({
        //   message: '价格日历加载中，请稍后',
        //   duration: 1000,
        //   color: '#000',
        //   background: 'transparent'
        // })
        uni.showToast({
          title: '价格日历加载中，请稍后',
          icon: 'none'
        })
      }
    },
    formatDate(d) {
      return moment(d).format('YYYY-M-D')
    },
    transformDate(d) {
      let date = new Date(d.replace(/-/gm, '/'))
      return moment(date).format('YYYY-M-D')
    },
    handeldetermine(date) {
      if (date.checkInDate !== '') {
        // rangeObj 已清空，本身日态就是由该区间取的值，所以不需要再比较时间了
        this.info.checkInDate = date.checkInDate
        this.calanderLoading = true
        this.$ajax({
          method: 'post',
          url: '/weChat/ticket/queryDayStateByDateRange',
          data: {
            memberId: this.memberId,
            productId: this.id,
            // groupId: 104,
            beginDate: this.addZero(date.checkInDate),
            endDate: this.addZero(date.checkInDate)
          }
        }).then((result) => {
          if (result.data) {
            let item = result.data.map(t => {
              t.date = this.formatDate(t.date)
              t.saleSettlementPrice = t.settlementPrice
              return t
            })[0]
            this.forms.price = item.settlementPrice
            if (!item.stock) { // 已售罄
              // this.forms.minNum = 0
              // this.forms.maxNum = 0
              // this.forms.num = 0
              uni.showToast({
                title: '您选择的日期当前没有库存',
                icon: 'none'
              })
            } else {
              if (parseInt(this.dataFromFather.maxBugNum || 99) <= parseInt(item.stock)) {
                this.forms.maxNum = this.dataFromFather.maxBugNum || 99
              } else {
                this.forms.maxNum = item.stock
              }
              if (parseInt(this.dataFromFather.minBuyNum || 1) <= parseInt(item.stock)) {
                this.forms.minNum = this.dataFromFather.minBuyNum || 1
              } else {
                this.forms.minNum = item.stock
              }
              this.forms.num = this.forms.minNum || 1
            }
          }
          this.calanderLoading = false
          this.defaultTxt = ''
        }).catch(res => {
          this.calanderLoading = false
        })
        // }
      }
      // }
      this.handelClose()
    },
    handelClose() {
      this.close = true
      setTimeout(() => {
        this.IsCalender = false
      }, 300)
      this.showPaymentSelect = false
      this.submitLoading = false
    },
    testName() {
      return !!this.forms.contactName && /^[\u4E00-\u9FA5A-Za-z]+$/.test(this.forms.contactName)
    },
    testPhone() {
      return /^1[345789]\d{9}$/.test(this.forms.tel)
    },
    testID() {
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.forms.IDNumber)
    },
    tests() {
      let _boolean
      if (this.defaultTxt !== '') {
        return _boolean
      }
      if (this.isNeedID) {
        _boolean = this.testName() && this.testPhone() && this.testID()
      } else {
        _boolean = this.testName() && this.testPhone()
      }
      return _boolean
    },
    addZero(d) {
      let date
      if (d === '') {
        return moment(new Date()).format('YYYY-MM-DD')
      } else {
        date = new Date(d.replace(/-/gm, '/'))
        return moment(date).format('YYYY-MM-DD')
      }
    },
    orderNameInput(e) {
      this.forms.contactName = e.target.value
    },
    orderPhoneInput(e) {
      this.forms.tel = e.target.value
    },
    orderIDInput(e) {
      this.forms.IDNumber = e.target.value
    },
    bindChange(val) {
      this.forms.num = val
    },
    changeStepper(d) {
      setTimeout(() => {
        this.forms.num = parseInt(d) || 0
      }, 10)
    },
    async submit() {
      if (this.tests()) {
        if (this.submitLoading) {
          return false
        }
        this.submitLoading = true
        // let validEnd
        // if (parseInt(this.dataFromFather.validType) === 0) {
        //   validEnd = this.startDate
        // } else {
        //   validEnd = this.dataFromFather.validEndDate
        // }
        this.$ajax({
          method: 'post',
          url: '/weChat/ticket/orderTicket',
          data: {
            id: this.dataFromFather.id,
            memberId: this.memberId,
            // sProductId: this.dataFromFather.sProductId,
            // aProductId: this.dataFromFather.aProductId,
            // productTypeCode: this.dataFromFather.productTypeCode,
            playDate: this.startDate,
            totalPrice: this.originalPrice, // 订单总价
            settlementPrice: this.forms.price || 0, // this.dataFromFather.settlementPrice,
            isDiscount: this.couponCode ? 1 : 0, // * 是否使用优惠券 * 0：否 * 1：是
            discountPrice: this.countPrice, // 优惠金额:当is_discount=1时，该字段必填
            couponCode: this.couponCode, // 优惠券ID
            payPrice: this.price, // 实付总价
            totalQuantity: this.forms.num,
            orderName: this.forms.contactName,
            orderPhone: this.forms.tel,
            idCard: this.forms.IDNumber
          }
        }).then((result) => {
          if (result.success) {
            this.orderId = result.data
            this.showPaymentSelect = true
            // this.payOrder()
            this.submitLoading = false
          } else if (result.errCode == 8500){
            this.submitLoading = false
          }
        }).catch(() => {
          this.submitLoading = false
        })
      } else {
        this.isNameError = !this.testName()
        this.isPhoneError = !this.testPhone()
        if (parseInt(this.dataFromFather.isCard) === 1) {
          this.isIDError = !this.testID()
        }
        uni.showToast({
          title: '订单信息不正确',
          icon: 'none'
        })
      }
    },
    changePrice(msg) {
      this.countPrice = msg.couponDenomination || 0
      this.couponCode = msg.childCouponCode
      // console.log('changePrice:',msg, this.countPrice)
    },
    // 选择优惠券的回调函数,count是折扣金额，id是优惠券id
    // changePrice(count, id) {
    //   this.countPrice = count
    //   this.couponCode = id
    // },
    queryUserinfo() {
      if (this.memberId) {
        this.loading = true
        this.$ajax({
          method: 'post',
          url: '/weChat/member/queryById',
          data: {
            memberId: this.memberId
          }
        }).then((res) => {
          this.forms.tel = res.data.phone
          this.forms.contactName = res.data.memberName
          this.forms.IDNumber = res.data.idCard
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    queryData() {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/ticket/queryProductDetail',
        data: {
          id: this.id
          // sProductId: this.sProductId,
          // aProductId: this.aProductId,
          // productTypeCode: this.productTypeCode
        }
      }).then((res) => {
        this.dataFromFather = res.data
        this.forms.price = this.dataFromFather.settlementPrice
        if (parseInt(this.dataFromFather.maxBugNum || 99) <= parseInt(this.dataFromFather.stock)) {
          this.forms.maxNum = this.dataFromFather.maxBugNum || 99
        } else {
          this.forms.maxNum = this.dataFromFather.stock
        }
        if (parseInt(this.dataFromFather.minBuyNum || 1) <= parseInt(this.dataFromFather.stock)) {
          this.forms.minNum = this.dataFromFather.minBuyNum || 1
        } else {
          this.forms.minNum = this.dataFromFather.stock
        }
        this.forms.num = this.forms.minNum || 1
        // this.introduction = this.dataFromFather.otherInfo
        this.returnPrompt = this.dataFromFather.reservationInstructions
        if (this.dataFromFather.cancelType === 1) {
          this.cancelType = '可退，需确认'
        } else if (this.dataFromFather.cancelType === 2) {
          this.cancelType = '一经出售概不退换'
        } else {
          this.cancelType = '不可退'
        }
        if (parseInt(this.dataFromFather.isCard) === 1) {
          this.isNeedID = true
        } else {
          this.isNeedID = false
        }
        // this.queryUserinfo()
        this.timeInitial()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    async timeInitial() {
      // 时间的初始化
      let now = new Date()
      let advanceTime = this.dataFromFather.advanceTime // 提前预订时间
      let advanceDays = this.dataFromFather.advanceDays || 0 // 提前预定天数
      if (advanceTime) { // 时：分
        let time = advanceTime.split(':')
        // now.getHours() > time[0] && now.getMinutes() > time[1]
        if (now.getHours() > time[0]) { // 超过截止时间点的 当天不可订要再加一天
          advanceDays += 1
        } else if (now.getHours() < time[0]) {
        } else if (now.getMinutes() > time[1]) { // 超过截止时间点的 当天不可订要再加一天
          advanceDays += 1
        }
      }
      now.setDate(now.getDate() + advanceDays)
      if (parseInt(this.dataFromFather.validType) === 0) { // 提前预定
        // this.info.startDate = advanceDays ? this.formatDate(now) : ''
        if (advanceDays) {
          this.info.startDate = this.formatDate(now)
          if (this.info.checkInDate && now > new Date(this.info.checkInDate)) {
            this.info.checkInDate = this.info.startDate
          } else {
          }
        } else {
          this.info.startDate = ''
        }
        this.info.defaultOpenDate = this.info.startDate || ''
        this.rangeObj.start = this.info.startDate
      } else if (this.dataFromFather.validStartDate === '') { // 区间的 却缺少字段的异常处理
        this.rangeObj.start = this.currentDate
        let date = new Date(this.currentDate.replace(/-/gm, '/'))
        let time = date.setDate(date.getDate() + parseInt(this.dataFromFather.validDays) - 1)
        this.info.checkInDate = this.rangeObj.start
        this.rangeObj.end = this.formatDate(time)
        this.dataFromFather.validStartDate = this.rangeObj.start
        this.dataFromFather.validEndDate = this.rangeObj.end
      } else { // 区间
        let startTime = new Date(this.dataFromFather.validStartDate.replace(/-/gm, '/'))
        this.info.startDate = this.formatDate(now)
        this.rangeObj.start = now > startTime ? this.info.startDate : this.formatDate(startTime)
        this.info.checkInDate = this.rangeObj.start
        this.rangeObj.end = this.transformDate(this.dataFromFather.validEndDate)
        this.info.defaultOpenDate = this.rangeObj.start || ''
      }
      await this.getDateCalander(this.rangeObj)
      // console.log('rangeObj', {...this.rangeObj}, 'info', {...this.info}, 'range', this.range)
    },
    // 日期范围获取
    async getDateCalander(date) {
      // let beginDate = new Date()
      // let endDate = beginDate.setMonth(beginDate.getMonth() + 12)
      let beginDate
      let endDate
      if (date && date.start) { // 没有传开始、结束日期的时候，默认取今日到一年后
        beginDate = new Date(date.start.replace(/-/g, '/')) || new Date()
        if (date.end) {
          endDate = new Date(date.end.replace(/-/g, '/'))
        } else {
          endDate = (new Date()).setMonth(beginDate.getMonth() + 12)
        }
      } else {
        beginDate = new Date()
        endDate = (new Date()).setMonth(beginDate.getMonth() + 12)
      }
      this.calanderLoading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/ticket/queryDayStateByDateRange',
        data: {
          memberId: this.memberId,
          productId: this.id,
          // groupId: 104,
          beginDate: moment(beginDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD')
        }
      }).then((result) => {
        if (result.data) {
          this.range = result.data.map(t => {
            t.date = this.formatDate(t.date)
            t.saleSettlementPrice = t.settlementPrice
            return t
          })
          this.rangeObj = {}
        } else { // 没有可选的日态价格，所以日历就生成一个不可选的
          this.range = [{
            'costPrice': 0,
            'date': '1979-01-01',
            'isSelling': 0,
            'settlementPrice': 0.01,
            'stock': 0
          }]
          this.rangeObj = {}
        }
        this.calanderLoading = false
      }).catch(res => {
        this.calanderLoading = false
      })
    },
    /* getCoupon() {
      let _this = this
      this.$ajax({
        method: 'post',
        url: '/weChat/coupon/queryCouponByMember',
        data: {
          memberId: this.memberId,
          productId: this.id
        },
        success: function (res) {
          if (res.data) {
            let data = _this.renderCoupon(res.data)
            _this.coupons = data.filter(t => {
              return t.useType === 0
            })
          }
        }
      })
    },
    renderCoupon(data) {
      return data.map(t => {
        return {
          ...t,
          id: t.childCouponCode,
          oringinId: t.id,
          available: 1,
          useType: t.useType,
          discount: 0,
          denominations: t.couponDenomination,
          // originCondition: t.useDoorsill,
          origin_condition: t.useDoorsill === 0 || t.useDoorsill === null ? '无使用门槛' : `满${t.useDoorsill}减${t.couponDenomination}`,
          reason: '',
          value: t.useDoorsill
          // startAt: t.useValidStartDate / 1000,
          // endAt: t.useValidEndDate / 1000
        }
      })
    } */
  }
}
